var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.23 2.738a2.01 2.01 0 0 1 1.417 1.416c.528 2.126.406 5.484.01 7.692a2.011 2.011 0 0 1-1.416 1.416C13 13.6 8.002 13.6 8.002 13.6s-4.997 0-6.239-.338a2.01 2.01 0 0 1-1.416-1.416C-.184 9.73-.039 6.37.337 4.164A2.01 2.01 0 0 1 1.753 2.75C2.995 2.41 7.992 2.4 7.992 2.4s4.997 0 6.239.338ZM10.548 8l-4.146 2.4V5.6L10.547 8Z",
  fill: "currentColor"
})));
export default SvgYoutube;